/**
 * Time helper utilities for itinerary planning
 */

/**
 * Convert time string (HH:MM) to minutes since midnight
 */
export const timeToMinutes = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

/**
 * Convert minutes since midnight to time string (HH:MM)
 */
export const minutesToTime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

/**
 * Add minutes to a time string
 */
export const addMinutes = (timeStr, minutesToAdd) => {
  const totalMinutes = timeToMinutes(timeStr) + minutesToAdd;
  return minutesToTime(totalMinutes);
};

/**
 * Calculate time difference in minutes between two time strings
 */
export const timeDifference = (startTime, endTime) => {
  return timeToMinutes(endTime) - timeToMinutes(startTime);
};

/**
 * Format time for display (e.g., "10:00 AM")
 */
export const formatTime = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${String(minutes).padStart(2, '0')} ${period}`;
};

/**
 * Check if a time is between two other times
 */
export const isTimeBetween = (time, startTime, endTime) => {
  const timeMins = timeToMinutes(time);
  const startMins = timeToMinutes(startTime);
  const endMins = timeToMinutes(endTime);
  return timeMins >= startMins && timeMins <= endMins;
};

/**
 * Validate that time blocks don't conflict
 */
export const validateTimeBlocks = (timeBlocks) => {
  const conflicts = [];
  const sorted = [...timeBlocks].sort((a, b) => 
    timeToMinutes(a.lockedTime) - timeToMinutes(b.lockedTime)
  );

  for (let i = 0; i < sorted.length - 1; i++) {
    const current = sorted[i];
    const next = sorted[i + 1];
    
    // Assume minimum duration of 30 minutes if not specified
    const currentEnd = addMinutes(current.lockedTime, current.durationMinutes || 30);
    
    if (timeToMinutes(currentEnd) > timeToMinutes(next.lockedTime)) {
      conflicts.push({
        item1: current.name,
        item2: next.name,
        time1: current.lockedTime,
        time2: next.lockedTime,
      });
    }
  }

  return conflicts;
};



